import type { FaireProductEntity } from "../../entity_types/product";

export const p_jqz5ncjhcc: FaireProductEntity = {
  token: "p_jqz5ncjhcc",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Verdant (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/877fb02678d21d2a85f9c76df390077915b0ab86b7942fdcdc935a50cfd9f58c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/434d26ea9b1d88d5d389e3af93f1efa0eaddf650d42505cd1a3aa4be36299d6d.jpeg",
    "https://cdn.faire.com/fastly/f81e716198f80ae4113a3056f809e004545813ce62641e6dc04dcee18898ea8a.jpeg",
    "https://cdn.faire.com/fastly/4e262dd2128e39a4a7f5a77448719ae3a7c23c1186f6aaf1444465c401a0f978.jpeg",
    "https://cdn.faire.com/fastly/d6134fa2bf5038295a6aa16d3af0f9ed504ff4deea427ddcf3e2303936055629.jpeg",
    "https://cdn.faire.com/fastly/0c693aff0ca0bf55927fb73eaaf8cda75d4c067c5650c9bb8dab5b8313618e56.jpeg",
    "https://cdn.faire.com/fastly/7eec509fa5c1e6e2a3c7c1ad8e522c4fa264fa2bfc69fa3807e116b6419a1cc6.jpeg",
    "https://cdn.faire.com/fastly/f21b0cc0dcbb2d145d0d8afcf5e6b7f838f0b719a547b42336346344737309a9.jpeg",
    "https://cdn.faire.com/fastly/c9c024ec4c54998208b806a6888b3a579bbbf58f2e3bc7f70929dc0c5504f260.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:20.708Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
